import React from 'react';
import { BadgeQuestionMark, ChevronDown } from 'lucide-react';

interface HelpProps {
    isOpen: boolean;
    onToggle: () => void;
}

const Help: React.FC<HelpProps> = ({ isOpen, onToggle }) => {
    return (
        <div className="bg-white rounded-xl shadow-sm border">
            <button
                onClick={onToggle}
                className="w-full flex items-center justify-between p-4 cursor-pointer transition-colors"
            >
                <div className="flex items-center gap-3">
                    <BadgeQuestionMark size={20} className="text-cyan-600"/>
                    <span className="font-medium text-gray-800">راهنمای استفاده</span>
                </div>
                <ChevronDown
                    size={20}
                    className={`text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                />
            </button>

            {isOpen && (
                <div className="border-t p-6 space-y-4">
                    <p className="text-gray-600 text-sm mb-1">
                        جهت استفاده فایل تولیدی را در مسیری ذخیره کنید در هاست و سپس آدرس آن را که به دست اوردید مانند
                    </p>
                    <p className="text-gray-600 text-sm mb-1">
                        http://172.20.40.131/storage/haram/haram.json
                    </p>
                    <p className="text-gray-600 text-sm mb-3">
                        در قسمت پارامتر در ویجت اپلیکیشن ساینیج به صورت زیر قرار دهید:
                    </p>
                    <pre dir={'ltr'}
                         className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-xs leading-relaxed max-h-80 overflow-y-auto">
                        netbee://stream.netbee.online?url=http://172.20.40.131/storage/haram/haram.json
                    </pre>
                </div>
            )}
        </div>
    );
};

export default Help; 